export default "__VITE_ASSET__a4d30361__"